/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateSortCriteria {
    getFixupPrototypeFunction() { return AutomationTemplateSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateSortCriteria>): AutomationTemplateSortCriteria {
        let obj = Object.assign(new AutomationTemplateSortCriteria(), model);
        AutomationTemplateSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateSortCriteria>): AutomationTemplateSortCriteria {
        if (!model) return null;
        return AutomationTemplateSortCriteria.newInstance(<AutomationTemplateSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateSortCriteria) {
        if (!obj) return;

        models.AutomationTemplateSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateSortCriteria): boolean {
        Object.setPrototypeOf(obj, AutomationTemplateSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AutomationTemplateSortColumn;

    ascending: boolean;

}
